export const cwkWorks = {
  album: [
    {
      id: 13,
      title: '미끄럼틀',
      year: '2026.06.04.',
      image: require('./album/slide.webp'),
      link: 'https://music.bugs.co.kr/album/4149012',
    },
    {
      id: 12,
      title: '지우개 달린 연필',
      year: '2025.11.08.',
      image: require('./album/pencil-with-eraser.webp'),
      link: 'https://music.bugs.co.kr/album/4132813',
    },
    {
      id: 11,
      title: '주의 은혜라',
      year: 'CCM Single',
    },
    {
      id: 10,
      title: '너를 만나서',
      year: '10th Single',
    },
    {
      id: 9,
      title: '떨어진다',
      year: '9th Single',
    },
    {
      id: 8,
      title: '없지만',
      year: '8th Single',
    },
    {
      id: 7,
      title: '네가 없는 밤',
      year: '7th Single',
    },
    {
      id: 6,
      title: '이게 내 맘이죠',
      year: '6th Single',
    },
    {
      id: 5,
      title: '허락해줘요',
      year: '5th Single',
    },
    {
      id: 4,
      title: '이 여름이 끝나기 전에',
      year: '4th Single',
    },
    {
      id: 3,
      title: '널 놓치고 싶지가 않아',
      year: '3rd Single',
    },
    {
      id: 2,
      title: '내가 네게',
      year: '2nd Single',
    },
    {
      id: 1,
      title: '별거없었어',
      year: '1st Single',
    },
  ],
};
